import React, { lazy } from 'react';
import {
    DockviewReact,
    DockviewDefaultTab,
    themeDark,
    themeLight
} from 'dockview';
import ActivityBar from './ActivityBar'
import 'dockview/dist/styles/dockview.css';
import Welcome from '../welcome';
import StatusBar from './StatusBar';
import WelcomeContainer from '../welcome/ExtensionWelcomeContainer';
import ExtWelcomeTabContainer from '../welcome/ExtWelcomeTabContainer';
import ExtSideBarContainer from '../extensions/ExtSideBarContainer';
import ExtSibebarTab from '../extensions/ExtSibeBarTab';
import { Icon, Toaster, Position } from '@blueprintjs/core';
import * as Blueprint from '@blueprintjs/core';
import * as DataTable from 'ag-grid-react';
import * as Dockview from 'dockview';
import { Observable, from, Subject, share } from 'rxjs';
import  HelpSideBar from '../help/HelpSideBar';
import ExtensionSidebar from '../extensions/ExtensionSideBar';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css'; 
import { EXTENSION_ASSETS_URL, fetchUserExtensions, API_BASE_URL } from '../../services/api';
import { useSelector } from 'react-redux';
import ExtensionInfo from '../extensions/ExtensionInfo'
import { gl } from 'date-fns/locale';
import { registerExtension} from '../extensions/extensions-actions';
import { useDispatch } from 'react-redux';
import Output from './Output';
import SecondaryContainer from './SecondaryContainer';
import SecondaryTabContainer from './SecondaryTabContainer';
import { logOutOfApp } from '../session/session-actions';
import Settings from '../settings/Settings';
import SettingsSidebarPanel from '../settings/SettingsSidebarPanel';
import { registerBipLauncher, preloadBip, BIP_EXTENSION_NAME } from './bipLauncher';
import {
    getStoredTheme,
    applyTheme,
    getTheme as readTheme,
    THEME_CHANGED_COMMAND
} from './theme';

const SettingsPanel = React.memo(({ panelProps }) => (
    <Settings
        initialActiveItem={panelProps?.params?.initialActiveItem}
    />
));

// Create a global toaster instance
const AppToaster = Toaster.create({
    position: Position.TOP_RIGHT,
    maxToasts: 5,
});

const UILayout = (props) => {
    console.log('UILayout.props:', props);
    const { extConfig } = props;
    // Only this (standalone, single-extension) layout ever renders — the main
    // multi-extension app's UILayout.js never sets this. Extensions running
    // here (BIP in particular) use it to tell whether the session token
    // (`bodapro.auth.getToken`) is a real BodaPro-account JWT or the
    // extension's own separate login — see extConfig.webOptions.requiresAuth.
    React.useEffect(() => {
        if (!window.bodapro) window.bodapro = {};
        window.bodapro.standalone = true;
        window.bodapro.extConfig = extConfig;
    }, [extConfig]);
    const { userDetails } = useSelector(state => state.session);
    const userDetailsRef = React.useRef(userDetails);
    React.useEffect(() => {
        userDetailsRef.current = userDetails;
    }, [userDetails]);
    const GROUPS = ['primary-sidebar', 'main-panel', 'bottom-panel', 'secondary-sidebar', 'status-bar', 'active-bar'];
    const [api, setApi] = React.useState();
    const dispatch = useDispatch();

    const [availablePanels, setAvailablePanels] = React.useState(GROUPS);

    const [refreshKey, setRefreshKey] = React.useState(0);
    // let layoutEvent = null;
    const [ layoutEvent, setLayoutEvent ] = React.useState(null);
    const [theme, setThemeState] = React.useState(() => getStoredTheme());

    React.useEffect(() => {
        applyTheme(theme);
    }, [theme]);

    const [ commands$, setCommands$ ] = React.useState({
        'layout-ready': new Subject(),
        [THEME_CHANGED_COMMAND]: new Subject()
    });

    const [componentList, setComponentList] = React.useState({
        // activityBar: ActivityBar,
        loading: (props) => <div style={{marginTop: '50px'}}><Spinner SpinnerSize={40}></Spinner></div>,
        activityBar: (props) => <ActivityBar contributions={[]} {...props} commands$={commands$} getCommands$={function () { return commands$;}}/>,
        // welcomePanel: Welcome,
        welcomePanel: WelcomeContainer,
        primarySideBar: ExtSideBarContainer,
        statusBar: StatusBar,
        // helpSideBar: HelpSideBar,
        secondaryContainer: SecondaryContainer,

        extensionSideBar: ExtensionSidebar,
        'extension-info': ExtensionInfo,
        settingsPanel: SettingsPanel,
        settingsSidebarPanel: SettingsSidebarPanel,

        // default: (props: IDockviewPanelProps<{ title: string }>) => {
        default: (props) => {
            return (
                <div style={{ padding: '20px' }}>
                    { //props.params.title
                    }
                </div>
            );
        },
    });

    //save layout
    // React.useEffect(() => {
    //     if(!api) {
    //         return;
    //     }
        
    //     const disposable = api.onDidLayoutChange(() => {
    //         const layout = api.toJSON();
    //         console.log('layout:', layout);
    //         // localStorage.setItem('bodapro_layout', JSON.stringify(layout));
    //     });
        
    //     return () => disposable.dispose();
    // }, [api]);

    //globalThis
    globalThis['commands$'] = globalThis['commands$'] || commands$;
    if (!globalThis['commands$'][THEME_CHANGED_COMMAND]) {
        globalThis['commands$'][THEME_CHANGED_COMMAND] = commands$[THEME_CHANGED_COMMAND] || new Subject();
    }
    globalThis['bodaproComponents'] = globalThis['bodaproComponents']  || componentList;

    //installed extensions
    globalThis['BODAPRO_EXTENSIONS'] = globalThis['BODAPRO_EXTENSIONS'] || [];

    //extension load paths (used by getExtensionPath)
    globalThis['extensionPaths'] = globalThis['extensionPaths'] || {};

    //Panel components
    let components = {};
    let _extComponents = {};
    let _commands = {};
    let tabs = {};
  
        //setup bodaContext
    //---------------------------------------------------
    window['bodapro-context'] = {

        updateExtensionList : (extensionName) => {
            globalThis['BODAPRO_EXTENSIONS'] = globalThis['BODAPRO_EXTENSIONS'] || [];
            if (globalThis['BODAPRO_EXTENSIONS'].indexOf(extensionName) === -1) {
                globalThis['BODAPRO_EXTENSIONS'].push(extensionName);
            }
        },

        getExntesionList: () => {
            return globalThis['BODAPRO_EXTENSIONS'];
        },

        // Get the path from which an extension was loaded
        getExtensionPath: function (extensionName) {
            return globalThis['extensionPaths']?.[extensionName] || null;
        },

        // Internal: Register an extension's load path (called during extension activation)
        _registerExtensionPath: function (extensionName, path) {
            globalThis['extensionPaths'] = globalThis['extensionPaths'] || {};
            globalThis['extensionPaths'][extensionName] = path;
        },

        // activateExtension:  async (extensionName)  => {
        //     console.log('activating extension:', extensionName);

        //     //web
        //     if(bodapro.platformType === 'web'){
        //         const entryURL  = `${EXTENSION_ASSETS_URL}/${ext.extension.name}/entry.js`;
        //         const icon = `${EXTENSION_ASSETS_URL}/${ext.extension.name}/assets/${ext.extension.name}.svg`;
        //         const someThing = await import(/* webpackIgnore: true */ entryURL);

        //         _contributions.push({
        //             'id': ext.extension.identifier, //extensionPackage.id,
        //             'name': ext.extension.name, //extensionPackage.name,
        //             'label': ext.extension.name, //extensionPackage.label,
        //             'version': ext.version, //extensionPackage.version,
        //             'description': ext.description, //extensionPackage.description,
        //             'icon': icon, //extensionPackage.icon.endsWith('.svg') ? bodapro.path.join(extDir, extensionPackage.icon) : extensionPackage.icon,
        //         });

        //         const importExt = someThing.default(); //----

        //         setCommands$({ ...commands$, ..._commands});
        //         globalThis['commands$'] = { ...globalThis['commands$'], ..._commands};
        //         setActivityBarContributions(_contributions);
        //     }

        // },

        //bts api 
        api: bodapro,

        getTheme: function () {
            return readTheme();
        },

        setTheme: function (nextTheme) {
            if (nextTheme !== 'light' && nextTheme !== 'dark') {
                return;
            }
            const applied = applyTheme(nextTheme);
            setThemeState(applied);
            globalThis.commands$ = globalThis.commands$ || {};
            if (!globalThis.commands$[THEME_CHANGED_COMMAND]) {
                globalThis.commands$[THEME_CHANGED_COMMAND] = new Subject();
            }
            globalThis.commands$[THEME_CHANGED_COMMAND].next({ theme: applied });
        },

        //addToast implmentation here 
        showToast: function (options) {
            const { message, intent = 'none', timeout = 3000, icon, action } = options;
            
            // Map intent strings to BlueprintJS Intent enum
            const intentMap = {
                'primary': Blueprint.Intent.PRIMARY,
                'success': Blueprint.Intent.SUCCESS,
                'warning': Blueprint.Intent.WARNING,
                'danger': Blueprint.Intent.DANGER,
                'none': Blueprint.Intent.NONE
            };

            const toastOptions = {
                message: message,
                intent: intentMap[intent] || Blueprint.Intent.NONE,
                timeout: timeout,
            };

            // Add icon if provided
            if (icon) {
                toastOptions.icon = icon;
            }

            // Add action if provided
            if (action) {
                toastOptions.action = action;
            }

            return AppToaster.show(toastOptions);
        },       

        commands$: commands$,

        registerExecutableCommand: function (name, callback) {
            globalThis.executableCommands$ = globalThis.executableCommands$ || {};

            if (name in globalThis.executableCommands$) {
                console.warn(`Executable command ${name} already registered`);
                return;
            }

            globalThis.executableCommands$[name] = callback;
            console.log(`Executable command registered: ${name}`);
        },

        executeCommand: async function (commandName, args) {
            globalThis.executableCommands$ = globalThis.executableCommands$ || {};

            if (globalThis.executableCommands$[commandName] === undefined) {
                throw new Error(`Executable command '${commandName}' not found. Available commands: ${Object.keys(globalThis.executableCommands$).join(', ')}`);
            }

            try {
                return await globalThis.executableCommands$[commandName](args);
            } catch (error) {
                console.error(`Error executing command ${commandName}:`, error);
                throw error;
            }
        },

        deRegisterExecutableCommand: function (commandName) {
            if (globalThis.executableCommands$ && globalThis.executableCommands$[commandName] !== undefined) {
                delete globalThis.executableCommands$[commandName];
                console.log(`Executable command deregistered: ${commandName}`);
            }
        },

        registerCommand: function (name, callback) {

            if(name in  globalThis['commands$']) {
                return;
            }


            const observable = new Subject();
            observable.subscribe((args) => {
                if( typeof callback === 'function') callback(args);
            });

            setCommands$({
                ...commands$,
                [name]: observable
            });

            _commands[name] = observable;

            setCommands$({ ...commands$, ..._commands});
            // console.log('_commands:', _commands);
            globalThis['commands$'] = { ...globalThis['commands$'], ..._commands};
        },

        registerComponent: function (component) {
            components[component.id] = (panelProps) => <component.component 
                panelProps={panelProps}
                />;

            setComponentList({ ...componentList, ...components});
            globalThis['bodaproComponents'] = { ...globalThis['bodaproComponents'], ...components};
        },

        //trigger command
        triggerCommand: function (commandName, args) {
            if(globalThis.commands$[commandName] !== undefined) globalThis.commands$[commandName].next(args);
        },

        //subscribe to command
        subscribeToCommand: function (commandName, callback) {

            // if(commandName in globalThis.commands$) return;

            //add delay to make sure the command is available
            setTimeout(() => {
                if(globalThis.commands$[commandName] !== undefined) globalThis.commands$[commandName].subscribe((args) => {
                    if( typeof callback === 'function') callback(args);
                });
            }, 10);

        },

        addPanel: function ({id, title, componentName, groupId, extraProps, params, replacePanel}) {

            if(layoutEvent.api.getPanel(id) !== undefined && replacePanel !== true) {
                layoutEvent.api.getPanel(id).api.setActive();
                return;
            }

            //get primary side panel group 
            const panelGroup = (groupId !== undefined && GROUPS.indexOf(groupId) > -1) ? layoutEvent.api.getPanel(groupId).api.group : layoutEvent.api.getPanel('primary-sidebar').api.group;

            //clear current panel
            if(replacePanel && layoutEvent.api.getPanel(id) !== undefined){
                const _panel = layoutEvent.api.getPanel(id);
                layoutEvent.api.removePanel(_panel);
            }

            console.log('group:', panelGroup);
            setComponentList(window['bodaproComponents']);
            console.log('componentList:', componentList);
            
            const newPanel = layoutEvent.api.addPanel({
                id: id,
                component: componentName,
                title: title,
                position: { referenceGroup: panelGroup },
                ...extraProps,
                params
            });

        },

        setWelcomePanel: function (componentName) {
            layoutEvent.api.getPanel('main-panel').api.updateParameters({componentName});
        },

        /**
         * Set the parimary side bar 
         * 
         * @param {} componentName 
         */
        setSideBarPanel: function (componentName) {
            layoutEvent.api.getPanel('primary-sidebar').api.updateParameters({sideBarComponent: componentName});
        },

        updatePanelParams: function (panelId, params) {
            console.log('ee| :', panelId, params);
            if(layoutEvent.api.getPanel(panelId)) layoutEvent.api.getPanel(panelId).api.updateParameters(params);
 
        },

        // Hide a section/panel
        hideSection: function (sectionName) {
            if (layoutEvent === null) return;

            const panel = layoutEvent.api.getPanel(sectionName);
            if (!panel) return;

            // Initialize panel sizes storage if not exists
            globalThis.panelSizes = globalThis.panelSizes || {};

            // Always store current size and constraints before hiding
            const currentSize = panel.api.size;
            // Store default constraints based on panel type since getConstraints() doesn't exist
            let currentConstraints = {};
            if (sectionName === 'active-bar') {
                currentConstraints = { maximumWidth: 60, minimumWidth: 60 };
            } else if (sectionName === 'status-bar') {
                currentConstraints = { maximumHeight: 30, minimumHeight: 30 };
            } else {
                // For other panels, use empty constraints (no minimums set)
                currentConstraints = {};
            }
            globalThis.panelSizes[sectionName] = {
                ...currentSize,
                constraints: currentConstraints
            };

            // Hide panel - set minimum constraints to 0 FIRST, then set size to 0
            if (sectionName === 'bottom-panel' || sectionName === 'status-bar') {
                panel.api.group.api.setConstraints({
                    minimumHeight: 0,
                    maximumHeight: undefined
                });
                panel.api.setSize({ height: 0 });
            } else {
                panel.api.group.api.setConstraints({
                    minimumWidth: 0,
                    maximumWidth: undefined
                });
                panel.api.setSize({ width: 0 });
            }

            // Special handling: when primary sidebar is minimized, ensure secondary sidebar stays minimized
            if (sectionName === 'primary-sidebar') {
                const secondaryPanel = layoutEvent.api.getPanel('secondary-sidebar');
                const secondaryPanelData = globalThis.panelSizes['secondary-sidebar'];
                if (secondaryPanelData && secondaryPanelData.hidden) {
                    // Secondary sidebar was hidden, hide it again to ensure it stays hidden
                    if (secondaryPanel) {
                        secondaryPanel.api.group.api.setConstraints({
                            minimumWidth: 0,
                            maximumWidth: undefined
                        });
                        secondaryPanel.api.setSize({ width: 0 });
                    }
                }

                // reset the secondary sidebar constraints to allow it to be resized when primary sidebar is shown again
                if (secondaryPanelData === undefined || (secondaryPanelData && !secondaryPanelData?.hidden)) {
                    if(secondaryPanel) {
                        secondaryPanel.api.group.api.setConstraints({
                            minimumWidth: 300
                        });
                        secondaryPanel.api.setSize({ width: 300 });
                    }
                }
            }

            globalThis.panelSizes[sectionName].hidden = true;
        },

        // Show a section/panel . same as show PanelGroup
        showSection: function (sectionName) {
            if (layoutEvent === null) return;

            const panel = layoutEvent.api.getPanel(sectionName);
            if (!panel) return;

            // Initialize panel sizes storage if not exists
            globalThis.panelSizes = globalThis.panelSizes || {};

            const panelData = globalThis.panelSizes[sectionName];

            // Restore or set appropriate constraints first, then set size
            if (sectionName === 'bottom-panel') {
                panel.api.group.api.setConstraints({
                    minimumHeight: 50
                });
                panel.api.setSize({ height: 100 });
            } else if (sectionName === 'status-bar') {
                panel.api.group.api.setConstraints({
                    maximumHeight: 30,
                    minimumHeight: 30
                });
                panel.api.setSize({ height: 30 });
            } else if (sectionName === 'primary-sidebar') {
                panel.api.group.api.setConstraints({
                    minimumWidth: 200
                });
                panel.api.setSize({ width: 400 });
            } else if (sectionName === 'secondary-sidebar') {
                panel.api.group.api.setConstraints({
                    minimumWidth: 200
                });
                panel.api.setSize({ width: 300 });
            } else if (sectionName === 'active-bar') {
                panel.api.group.api.setConstraints({
                    maximumWidth: 60,
                    minimumWidth: 60
                });
                panel.api.setSize({ width: 60 });
            }

            if (panelData) {
                globalThis.panelSizes[sectionName].hidden = false;
            }
        },

        // Toggle hide/show a section/panel (legacy function)
        toggleSection: function (sectionName) {
            if (layoutEvent === null) return;

            const panel = layoutEvent.api.getPanel(sectionName);
            if (!panel) return;

            globalThis.panelSizes = globalThis.panelSizes || {};
            const isHidden = globalThis.panelSizes[sectionName]?.hidden || false;

            if (isHidden) {
                this.showSection(sectionName);
            } else {
                this.hideSection(sectionName);
            }
        },

        setAvailablePanels: function (panels) {
            setAvailablePanels(panels);
        },

        hidePanelGroupHeader: function (panelId) {
            if (layoutEvent === null) return;
            const panel = layoutEvent.api.getPanel(panelId);
            if (panel) {
                panel.group.header.hidden = true;
            }
        },

        showPanelGroupHeader: function (panelId) {
            if (layoutEvent === null) return;
            const panel = layoutEvent.api.getPanel(panelId);
            if (panel) {
                panel.group.header.hidden = false;
            }
        }


    };
    //eof: bodapro context---------------------------------------------------------------------------------------------------

    // Register core authentication executable commands
    window['bodapro-context'].registerExecutableCommand('bodapro.auth.getCurrentUser', async function () {
        const current = userDetailsRef.current;
        if (!current) {
            return {
                success: false,
                user: null,
                authenticated: false
            };
        }
        return {
            success: true,
            user: current,
            authenticated: true
        };
    });

    window['bodapro-context'].registerExecutableCommand('bodapro.auth.getApiBaseUrl', async function () {
        return {
            success: true,
            baseUrl: API_BASE_URL,
            environment: window?.location?.port === '3000' ? 'development' : 'production'
        };
    });

    window['bodapro-context'].registerExecutableCommand('bodapro.auth.getToken', async function () {
        const token = userDetailsRef.current?.token;

        if (!token) {
            return {
                success: false,
                token: null,
                authenticated: false,
            };
        }

        return {
            success: true,
            token,
            authenticated: true,
        };
    });

    // Dynamically activate an extension at runtime (web standalone mode)
    window['bodapro-context'].registerExecutableCommand('bodapro.extensions.activate', async function ({ name }) {
        if (!name) {
            throw new Error('Extension name is required');
        }

        try {
            // Check if already loaded. A registered load path is required —
            // the name alone in BODAPRO_EXTENSIONS is not proof of activation.
            if (globalThis['BODAPRO_EXTENSIONS'].indexOf(name) > -1 && globalThis['extensionPaths']?.[name]) {
                return {
                    success: true,
                    message: 'Extension is already activated',
                    name
                };
            }

            const platformType = (window.bodapro || globalThis.bodapro)?.platformType;

            if (platformType !== 'web') {
                throw new Error('Extension runtime activation is not supported on desktop standalone');
            }

            // Web platform - load from EXTENSION_ASSETS_URL
            const entryURL = `${EXTENSION_ASSETS_URL}/${name}/entry.js`;
            const extensionPath = `${EXTENSION_ASSETS_URL}/${name}`;

            // Register extension path BEFORE activation so the extension can query it
            window['bodapro-context']._registerExtensionPath(name, extensionPath);

            // Import and activate
            const module = await import(/* webpackIgnore: true */ entryURL);
            const activate = module.default;
            if (typeof activate === 'function') {
                activate();
            }

            // Update registry (may already be listed)
            if (globalThis['BODAPRO_EXTENSIONS'].indexOf(name) === -1) {
                globalThis['BODAPRO_EXTENSIONS'].push(name);
            }
            dispatch(registerExtension(name));

            return {
                success: true,
                message: 'Extension activated successfully',
                name
            };
        } catch (error) {
            console.error(`Error activating extension ${name}:`, error);
            throw error;
        }
    });

    // Universal BIP launcher: bodapro.bip.open (lazy-loads bip if needed)
    registerBipLauncher();

    // Keyboard shortcuts for hiding/showing panels
    React.useEffect(() => {
        const handleKeyDown = (event) => {
            // Ctrl+B for primary sidebar toggle
            if (event.ctrlKey && event.key === 'b' && !event.shiftKey) {
                event.preventDefault();
                window['bodapro-context'].toggleSection('primary-sidebar');
            }
            // Ctrl+Shift+B for secondary sidebar toggle
            if (event.ctrlKey && event.shiftKey && event.key === 'B') {
                event.preventDefault();
                window['bodapro-context'].toggleSection('secondary-sidebar');
            }
            // Cmd+W or Ctrl+W to close active tab
            if ((event.metaKey || event.ctrlKey) && event.key === 'w') {
                event.preventDefault();
                if (layoutEvent && layoutEvent.api) {
                    const activeGroup = layoutEvent.api.activeGroup;
                    if (activeGroup && activeGroup.activePanel) {
                        const activePanel = activeGroup.activePanel;
                        // Don't close system panels
                        if (!GROUPS.includes(activePanel.id)) {
                            layoutEvent.api.removePanel(activePanel);
                        }
                    }
                }
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [layoutEvent]);

    // Register the toggle-layout-section command
    window['bodapro-context'].registerCommand('toggle-layout-section', function (params) {
        const { sectionName } = params;
        window['bodapro-context'].toggleSection(sectionName);
    });
    window['bodapro-context'].api.logout = () => {
        dispatch(logOutOfApp());
    };
    
    
    const fn = async () => {

        if(layoutEvent === null) return;

        // get extension list  
        let extensions =  [];

        // let _extComponents = {};
        // let _commands = {};
        let _contributions = [];

        //---WEB extensions
        //--------------------------------------------------------
        if(bodapro?.platformType === 'web'){
            // const ext = await import('file:./extensions/extension1/dist/extension1.js');
            extensions = []; //await fetchUserExtensions(userDetails?.token);    
            
            const entryURL  = `${EXTENSION_ASSETS_URL}/${extConfig.name}/entry.js`;
            const icon = `${EXTENSION_ASSETS_URL}/${extConfig.name}/assets/${extConfig.name}.svg`;

            // Register extension path BEFORE activation so the extension can query it
            window['bodapro-context']._registerExtensionPath(extConfig.name, `${EXTENSION_ASSETS_URL}/${extConfig.name}`);

            // const someThing = await import(/* webpackIgnore: true */ ext.url);
            const someThing = await import(/* webpackIgnore: true */ entryURL);

            _contributions.push({
                'id': extConfig.id, //extensionPackage.id,
                'name': extConfig.name, //extensionPackage.name,
                'label': extConfig.name, //extensionPackage.label,
                'version': extConfig.version, //extensionPackage.version,
                'description': extConfig.description, //extensionPackage.description,
                'icon': icon, //extensionPackage.icon.endsWith('.svg') ? bodapro.path.join(extDir, extensionPackage.icon) : extensionPackage.icon,
            });

            const importExt = someThing.default({standalone: true}); //----

            // Track the host extension so context-aware extensions (e.g. BIP) see it
            window['bodapro-context'].updateExtensionList(extConfig.name);

            setCommands$({ ...commands$, ..._commands});
            globalThis['commands$'] = { ...globalThis['commands$'], ..._commands};
            setActivityBarContributions(_contributions);

            //update the component list
            setComponentList(globalThis['bodaproComponents']);

            // Lazy-load BIP in the background so it is available from the status bar
            if (extConfig.name !== BIP_EXTENSION_NAME) {
                preloadBip();
            }

            let cmdCheckInt = null;
            cmdCheckInt = setInterval(() => {
                if(globalThis.commands$[extConfig.id] !== undefined) {
                    globalThis.commands$[extConfig.id].next(extConfig.name);
                    clearInterval(cmdCheckInt);
                }
            }, 2000);
            

            return;
        }
        //end of web|online ------------------------------------------------------ONLINE


        

        return;

        //---desktop extensions
        //--------------------------------------------------------
        extensions = await bodapro.getInstalledExtensions();
        let idx = 0;
        for (const extension of extensions) {
            idx++;
            //const packageJson = path.join(extension, 'package.json');
            const extensionPackage = bodapro.require(extension);
            const extDir = bodapro.path.dirname(extension);

            const entryFile = bodapro.path.join(extDir,extensionPackage.entry);

            //check if entry files exists 
            if(!bodapro.fs.existsSync(entryFile)) continue;
            _contributions.push({
                'id': extensionPackage.id,
                'name': extensionPackage.name,
                'label': extensionPackage.label,
                'version': extensionPackage.version,
                'description': extensionPackage.description,
                'icon': extensionPackage.icon.endsWith('.svg') ? bodapro.path.join(extDir, extensionPackage.icon) : extensionPackage.icon,
            });
            
            // (async () => {
                try{
                    const someThing = await import(/* webpackIgnore: true */`file:${entryFile}`);
                    const importExt = someThing.default();
                // importExt.activate()
                }catch(e){
                    console.log('error:', e);
                }
            // })();
        }

        setCommands$({ ...commands$, ..._commands});
        globalThis['commands$'] = { ...globalThis['commands$'], ..._commands};
        setComponentList(globalThis['bodaproComponents']);

        setActivityBarContributions(_contributions);
    }


    //activityBar contributions 
    const [ activityBarContributions, setActivityBarContributions ] = React.useState([]);

    //Load extensions 
    React.useEffect(  () => {
        fn();
    }, [layoutEvent !== null]);  


React.useEffect(() => {

    if(layoutEvent === null){
        return;
    }
    const actvitiyBarPanel = layoutEvent.api.getPanel('active-bar');
    actvitiyBarPanel.api.updateParameters({
        contributions: activityBarContributions,
        'keyA': 'Testing A'
    });

}, [activityBarContributions.length, layoutEvent !== null]);

React.useEffect(() => {
    if (!layoutEvent || !layoutEvent.api) return;
    const currentPanels = layoutEvent.api.panels;
    currentPanels.forEach(panel => {
        if (GROUPS.indexOf(panel.id) === -1 && availablePanels.indexOf(panel.id) === -1) {
            layoutEvent.api.removePanel(panel.id);
        }
    });
}, [availablePanels, layoutEvent]);

    const PanelTab = (props) => {
        const onContextMenu = (event) => {
            event.preventDefault();
        };
        return <DockviewDefaultTab onContextMenu={onContextMenu} {...props} hideClose={true} />;
    };

    const BottomTab = (props) => {
        const onContextMenu = (event) => {
            event.preventDefault();
            // alert('context menu');
        };
        return <DockviewDefaultTab onContextMenu={onContextMenu} {...props} hideClose={true}/>;
    };

    const RightHeaderActions = (props) => {
        return (<div 
            style={{
                padding: 5,
                paddingTop: 10
            }}
            >
            <Icon icon="more" intent="secondary" />
        </div>);
    }

    //panel contents 
    components = {
        // activityBar: ActivityBar,
        activityBar: (props) => <ActivityBar contributions={[]} {...props} commands$={commands$} getCommands$={function () { return commands$;}}/>,
        welcomePanel: Welcome,
        statusBar: StatusBar,
        'extension-info': ExtensionInfo,

        // default: (props: IDockviewPanelProps<{ title: string }>) => {
        default: (props) => {
            return (
                <div style={{ padding: '20px' }}>
                    {props.params.title}
                </div>
            );
        },
    };

    //penal tabs 
    // let tabComponents = {
    //     panelTab: PanelTab,
    //     welcomeTab: PanelTab,
    //     outputTab: BottomTab
    // };

    const [ tabComponents, setTabComponents ] = React.useState({
        panelTab: PanelTab,
        welcomeTab: PanelTab,
        outputTab: BottomTab,
        extensionSideBar: PanelTab,
        secondaryTabContainer: SecondaryTabContainer,
        docsSideBar: PanelTab,
        noCloseTab: PanelTab,
    });

    const onReady = (event) => {
        setApi(event.api);

        //set layout dockview event
        // layoutEvent = event;
        setLayoutEvent(event);

        //activitybar
        const activeBar = event.api.addPanel({
            id: 'active-bar',
            component: 'activityBar',
            params: {
                title: 'Active Bar',
                contributions: []
            },
        });
        activeBar.group.locked = true;
        activeBar.group.header.hidden = true;
        activeBar.api.group.api.setConstraints({
            maximumWidth: 0,
            minimumWidth: 0,
        });
  
        //status bar 
        //----------------------------
        const statusBar = event.api.addPanel({
            id: 'status-bar',
            component: 'statusBar',
            title: 'Status',
            params: {
                title: 'Primary sidebar',
                bipContextKey: extConfig?.id
            },
            position: { referencePanel: 'active-bar', direction: 'below' },
        });
        statusBar.group.locked = true;
        statusBar.group.header.hidden = true;
        statusBar.api.group.api.setConstraints({
            maximumHeight: 30,
            minimumHeight: 30,
        });

        const primarySidebar = event.api.addPanel({
            id: 'primary-sidebar',
            // component: 'extensionSideBar',
            component: 'primarySideBar',
            title: 'EXTENSIONS',
            tabComponent: 'extensionSideBar', 
            params: {
                title: 'Primary sidebar'
            },
            position: { referencePanel: 'active-bar', direction: 'right' },
        });
        primarySidebar.api.setSize({width: 300});
        primarySidebar.group.locked = true;
        primarySidebar.group.hideClose = true;

        // //hide primary sidebar if not needed
        if(!extConfig?.webOptions?.panels.includes('primary-sidebar')){
            primarySidebar.api.group.api.setConstraints({
                maximumWidth: 0,
                minimumWidth: 0,
            });
        }else{
            primarySidebar.group.api.setSize({
                width: 300,
            });
        }

        
        // //main panel
        // //----------------------------
        const mainPanel = event.api.addPanel({
            id: 'main-panel',
            component: 'welcomePanel',
            title: 'Welcome',
            params: {
                title: 'Welcome',
            },
            tabComponent: 'welcomeTab', 
            position: { referencePanel: 'primary-sidebar', direction: 'right' },
        });
        mainPanel.group.locked = true;
        mainPanel.group.hideClose = true;


        //secondry sidebar
        //----------------------------
        const secondarySidebar = event.api.addPanel({
            id: 'secondary-sidebar',
            component: 'secondaryContainer',
            title: 'Documentation',
            tabComponent: 'secondaryTabContainer',
            params: {
                title: 'Documentation',
            },
            position: { referencePanel: 'main-panel', direction: 'right' },
        });

        if(!extConfig?.webOptions?.panels.includes('secondary-sidebar')){
            secondarySidebar.api.group.api.setConstraints({
                maximumWidth: 0,
                minimumWidth: 0,
            });
        }else{
            secondarySidebar.group.api.setSize({
                width: 300,
            });
        }

        //bottom panel
        //----------------------------
        //add if extension needs it 
        if(extConfig?.webOptions?.panels.includes('bottom-panel')){
            const bottomPanel = event.api.addPanel({
                id: 'botton-panel',
                component: 'default',
                title: 'OUTPUT',
                tabComponent: 'outputTab', 
                params: {
                    title: 'Bottom Panel',
                },
                position: { referencePanel: 'main-panel', direction: 'below' },
                
            });
            bottomPanel.api.setSize({height: 100});
        }

        // //set the parimary and secondary sidebar sizes again
        // //----------------------------
        primarySidebar.api.setSize({width: 400});
        secondarySidebar.api.setSize({width: 300});
    };



    return  <DockviewReact
        theme={theme === 'light' ? themeLight : themeDark}
        components={componentList}
        tabComponents={tabComponents}
        onReady={onReady}
        className={theme === 'light' ? 'dockview-theme-light' : 'dockview-theme-dark'}
        rightHeaderActionsComponent={RightHeaderActions}
    />
}

export default UILayout;